import { AddCircle, Clear, Delete, Edit, Search } from "@mui/icons-material";
import { Box, Card, CardContent, Grid } from "@mui/material";
import { GridActionsCellItem, GridRowId, GridRowModel, GridSortDirection, GridSortModel } from "@mui/x-data-grid";
import { useEffect, useMemo, useState } from "react";

import AutoComplete from "../../../components/hookForms/autoComplete";
import { Button } from "@mui/material";
import ConfirmationDialog from "../../../components/confirmationDialog";
import { Container } from "../../../theme/globalStyles";
import DataTable from "../../../components/dataTable";
import DialogEdit from "./modal/dialogEdit";
import DialogNew from "./modal/dialogNew";
import TextInput from "../../../components/hookForms/textField";
import Tooltip from "@mui/material/Tooltip";
import messages from "../../../utils/messages";
import serviceConfiguracaoAlarme from "../../../services/serviceConfiguracaoAlarme";
import { toast } from "react-toastify";
/* eslint-disable react-hooks/exhaustive-deps */
import { useAuth } from "../../../context/global";
import { useForm } from "react-hook-form";

const ConfiguracaoAlarme = (props: any) => {
    const { setTitlePage } = useAuth();

    useEffect(() => {
        setTitlePage("Alarmes - Configuração de Alarme");
    }, [setTitlePage]);

    const [data, setData] = useState<any[]>([]);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(0);
    const [filters, setFilters] = useState(null);
    const [rowCount, setRowCount] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const [openNew, setOpenNew] = useState(false);
    const [tipoDataOptions, setTipoDataOptions] = useState<any[]>([]);

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
            field: "",
            sort: "" as GridSortDirection,
        },
    ]);

    const [exclusionState, setExclusionState] = useState({
        data: "",
        open: false,
    });

    const [editState, setEditState] = useState({
        open: false,
        id: "",
        tipoAlarmeID: "",
        assunto: "",
        descricao: "",
        template: "",
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        defaultValues: {
            tipoAlarmeID: "",
            assunto: "",
            descricao: "",
        },
    });

    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operações",
                field: "operations",
                type: "actions",
                width: 170,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Editar">
                                <Edit />
                            </Tooltip>
                        }
                        label="Editar"
                        onClick={() =>
                            setEditState({
                                open: true,
                                id: params.id.toString(),
                                tipoAlarmeID: params.row.tipoAlarmeID,
                                assunto: params.row.assunto,
                                descricao: params.row.descricao,
                                template: params.row.template,
                            })
                        }
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Excluir">
                                <Delete />
                            </Tooltip>
                        }
                        label="Excluir"
                        onClick={() => setExclusionState({ data: params.id.toString(), open: true })}
                    />,
                ],
            },
        ],
        []
    );

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "configuracaoAlarmeID",
                type: "number",
                headerAlign: "left",
                identity: true,
                width: 70,
            },
            {
                headerName: "Tipo",
                field: "descricaoTipoAlarme",
                type: "string",
                width: 180,
            },
            {
                headerName: "Assunto",
                field: "assunto",
                type: "string",
                flex: 1,
            },
            {
                headerName: "Descrição",
                field: "descricao",
                type: "string",
                flex: 1,
            },
            ...actionColumns,
        ],
        [actionColumns]
    );

    const getAllWithFilters = async (filters: any) => {
        setData([]);
        setLoading(true);

        serviceConfiguracaoAlarme
            .getWithFilter({
                ...filters,
                take: pageSize,
                currentPage: page + 1,
                sortExpression: sortModel[0]?.field ?? "",
                sortDirection: sortModel[0]?.sort ?? "",
            })
            .then((result) => {
                setData(result?.data.content);
                setRowCount(result?.data.numberOfElements);
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
                setData([]);
                setRowCount(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(
        () => {
            getAllWithFilters(filters);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, pageSize, sortModel]
    );

    useEffect(() => {
        setDataTipo();
    }, []);

    const setDataTipo = () => {
        serviceConfiguracaoAlarme
            .getAllTipoAlarme(null)
            .then((result) => {
                if (result) {
                    setTipoDataOptions(result.data);
                }
            })
            .catch(() => {
                setTipoDataOptions([]);
            });
    };

    const handleDelete = async () => {
        serviceConfiguracaoAlarme
            .delete(exclusionState.data)
            .then((result) => {
                toast.success(messages.deleteSucess);
            })
            .catch((err) => {
                toast.error(messages.deleteError, err);
            })
            .finally(() => {
                setExclusionState({ data: "", open: false });
                getAllWithFilters(filters);
            });
    };

    const handleClickOpenNew = () => {
        setOpenNew(true);
    };

    const handleCloseNew = () => {
        setOpenNew(false);
    };

    const onSubmit = (values: any) => {
        const newFilters = {
            ...values,
            tipoAlarmeID: values.tipoAlarmeID,
        };

        setFilters(newFilters);
        getAllWithFilters(newFilters);
    };

    const onClear = () => {
        reset();
        setFilters(null);
        getAllWithFilters(null);
    };

    const onSuccessAction = () => {
        getAllWithFilters(filters);
    };

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={2}>
                                <Grid item md={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={2}>
                                            <AutoComplete
                                                name="tipoAlarmeID"
                                                label="Tipo"
                                                options={tipoDataOptions}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>

                                        <Grid item md={2}>
                                            <TextInput
                                                name="assunto"
                                                label="Assunto"
                                                control={control}
                                                error={errors}
                                                maxLength={100}
                                            />
                                        </Grid>

                                        <Grid item md={2}>
                                            <TextInput
                                                name="descricao"
                                                label="Descrição"
                                                control={control}
                                                error={errors}
                                                maxLength={100}
                                            />
                                        </Grid>

                                        <Grid item md={2}>
                                            <Button
                                                disableElevation
                                                variant="contained"
                                                color="warning"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Search />}
                                                type="submit"
                                                disabled={isLoading}
                                            >
                                                Pesquisar
                                            </Button>
                                        </Grid>

                                        <Grid item md={2}>
                                            <Button
                                                disableElevation
                                                variant="outlined"
                                                color="warning"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Clear />}
                                                onClick={() => onClear()}
                                            >
                                                Limpar
                                            </Button>
                                        </Grid>

                                        <Grid item md={2}>
                                            <Button
                                                style={{ marginTop: 16, marginBottom: 8 }}
                                                variant="contained"
                                                color="primary"
                                                startIcon={<AddCircle />}
                                                onClick={handleClickOpenNew}
                                                disableElevation
                                                fullWidth
                                                size="medium"
                                            >
                                                Novo
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>

                    <Box sx={{ height: 450 }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.configuracaoAlarmeID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                        />
                    </Box>

                    <ConfirmationDialog
                        open={exclusionState?.open}
                        title={"Excluir"}
                        message={messages.deleteConfirmation}
                        cancelButtonText={"Não"}
                        confirmButtonText={"Sim"}
                        onClose={() => setExclusionState({ data: "", open: false })}
                        onCancel={() => setExclusionState({ data: "", open: false })}
                        onConfirm={() => {
                            setExclusionState({ data: "", open: false });
                            handleDelete();
                        }}
                    />

                    <DialogNew
                        open={openNew}
                        onSuccess={() => onSuccessAction()}
                        onClose={() => {
                            handleCloseNew();
                        }}
                    />

                    <DialogEdit
                        open={editState.open}
                        onSuccess={() => onSuccessAction()}
                        data={{
                            open: editState.open,
                            id: editState.id,
                            tipoAlarmeID: editState.tipoAlarmeID,
                            assunto: editState.assunto,
                            descricao: editState.descricao,
                            template: editState.template,
                        }}
                        onClose={() => {
                            setEditState({
                                open: false,
                                id: "",
                                tipoAlarmeID: "",
                                assunto: "",
                                descricao: "",
                                template: "",
                            });
                        }}
                    />
                </CardContent>
            </Card>
        </Container>
    );
};

export default ConfiguracaoAlarme;
